<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import MyLocalStorage from "./utils/MyLocalStorage";
import langSet from "./lang/set.js";
export default {
  name: "App",
  created() {
    let user = MyLocalStorage.getUserInfo();
    if (user) {
      this.$store.commit("set_user", user);
    }
    const urlParams = new URLSearchParams(window.location.search);
    const langParams = urlParams.get("lang");
    // const isRepair = urlParams.get("feature") === "repair";
    // const isIos = urlParams.get("os_name") === "ios";

    // if (isRepair && !isIos) {
    //   // 针对安卓的repair模块暂时仅使用英语
    //   this.$i18n.locale = "en";
    //   document.documentElement.setAttribute("dir", "ltr");
    // } else {
    this.$i18n.locale = langSet.indexOf(langParams) !== -1 ? langParams : "en";
    document.documentElement.setAttribute(
      "dir",
      this.$i18n.locale === "ar" ? "rtl" : "ltr"
    );
    // }
  },
  mounted() {
    if (window.android) {
      window.android.finishLoading();
    }
  }
};
</script>

<style scoped>
#app {
  text-align: start;
}
</style>
